import axiosClient from "../axiosClient";

const route = "/organizationBelonging";

export const getOrganizationBelongings = async (params = {}) => {
  try {
    const response = await axiosClient.get(`${route}/getAll`, {
      params: {
        ...params,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const createOrganizationBelonging = async (data) => {
  try {
    const response = await axiosClient.post(`${route}`, {
      ...data,
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateOrganizationBelonging = async (id, data) => {
  try {
    const response = await axiosClient.put(`${route}/${id}`, {
      ...data,
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteOrganizationBelonging = async (id) => {
  const response = await axiosClient.delete(`${route}/${id}`);

  return response;
};
